<template>
  <div style="top:150px; width:5000px; height:5000px">
    <svg text-rendering="optimizeSpeed" id="all" style="display: inline; width: inherit; min-width: inherit; max-width: inherit; height: inherit; min-height: inherit; max-height: inherit;" version="1.1">
      <g id="maingroup" transform="translate(0,50)">
      <g>
        <DataConnection v-if="link.source.parent.children.length && link.target.parent.children.length && link.value>0" :key=link.id :link=link v-for="link in ordered_links"/>
      </g>


      <defs>
        <filter x="0" y="0" width="1" height="1" id="textbg">
          <feFlood flood-color="white" flood-opacity=".8"/>
          <feComposite in="SourceGraphic"/>
        </filter>
        </defs>

      <g>
        <DataColumn :key=c.id :column=c :column_id=cid v-for="(c,cid) in columns" />
      </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as d3 from 'd3'

import DataNode from '@/components/DataNode'
import DataConnection from '@/components/DataConnection'
import DataColumn from '@/components/DataColumn'

export default {
  name: 'Sankey',
  props: [],
  components: {DataNode,DataConnection,DataColumn},
  mounted(){

    d3.select("#all").call(d3.zoom()
                           .scaleExtent([.3, 15])
                           .on("zoom", zoom))

    function zoom() {
      d3.select("#maingroup").attr("transform", d3.event.transform);
    }
  },
  data(){ return {} },
  computed:{
    ...mapGetters(['columns']),
    ...mapState(['links']),
    ordered_links(){
      var vals = Object.values(this.links)
      vals.sort( (l1,l2)=>{
        if (l1.is_loss) return -1e9
        return l2.source.column - l1.source.column
      })
      return vals
    }
  },
  methods:{
    reset_current(){
      this.$store.commit("setCurrentNode",null)
      this.$store.commit("setUpDown",null)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Sankey.vue